import React from 'react';
import LayoutDashBoard from '../../../components/layoutDashBoard/LayoutDashBoard'
import { TokenInput } from '../../../components/ui/Input';
import Title from '../../../components/ui/Title';
import BankDetails from './BankDetails';
import { useLoan } from './hook/useLoan'
import { LoanSimulator } from './LoanSimulator';
import AddressDetails from './AddressDetails';
import IdentityDetails from './IdentityDetails';
import { Button } from '../../../components/ui/Button';

const Loan = () => {
    const {
        loans,
        isRequiredToken,
        onSendToken,
        getLoans,
        bankDetails,
        loanSelected,
        setLoanSelected,
        solicitationValue,
        setSolicitationValue,
        installments,
        setInstallments,
        onSendSimulation,
        addressDetails,
        identityDetails,
        income,
        setIncome,
        noResults,
        setTrySimuation
    } = useLoan();
    return (
        <LayoutDashBoard>
            {!noResults && <React.Fragment>
                {loanSelected && <IdentityDetails identityDetails={identityDetails} />}
                {loanSelected && <AddressDetails addressDetails={addressDetails} />}
                {loanSelected && <BankDetails bankDetailsForm={bankDetails} />}
                {!loanSelected && <React.Fragment>
                    {!isRequiredToken
                        && <LoanSimulator
                            setLoanSelected={setLoanSelected}
                            loans={loans}
                            solicitationValue={solicitationValue}
                            setSolicitationValue={setSolicitationValue}
                            installments={installments}
                            setInstallments={setInstallments}
                            onSendSimulation={onSendSimulation}
                            income={income}
                            setIncome={setIncome}
                        />}
                    {isRequiredToken &&
                        <div>
                            <div className="flex items-center justify-center">
                                <Title
                                    text1={'Informe o token recebido'}
                                    text2={'por SMS para liberar a consulta'}
                                />
                            </div>
                            <TokenInput
                                onResend={() => getLoans(true)}
                                onComplete={(token) => onSendToken(token)}
                                label={'Digite o token enviado'}
                            />
                        </div>
                    }
                </React.Fragment>
                }
            </React.Fragment>}
            {noResults && <div className="flex flex-col items-center justify-center p-6">
                <p className="text-gray-700 mb-4">Nenhuma simulação foi aprovada :(</p>
                <Button
                    onClick={setTrySimuation}
                >
                    Voltar e tentar novamente
                </Button>
            </div>
            }
        </LayoutDashBoard>
    )
}

export default Loan